import React, { useContext } from 'react';
import { useTranslation } from 'next-i18next';

import { BUTTON_VARIANTS } from '@common/components/Button';
import { StepTitle, NextButton, ButtonText } from '../MobileOrderForm.styled';
import { CostsInfo } from '../components';
import { FormContext } from '../FormWrapper';

import SummaryFormSection from './SummaryFormSection';

const Summary = () => {
  const { t } = useTranslation();
  const { handleSubmit, isFormSending } = useContext(FormContext);

  return (
    <React.Fragment>
      <StepTitle>
        {t('mobile.orderForm.confirmation.heading', 'Zusammenfassung')}
      </StepTitle>
      <CostsInfo />
      <SummaryFormSection />
      <NextButton
        onClick={handleSubmit}
        type="submit"
        variant={BUTTON_VARIANTS.LEVEL_1_GREEN}
        disabled={isFormSending}
      >
        <ButtonText>
          {t(
            'mobile.orderForm.confirmation.sumbitButtonLabel',
            'Jetzt bestellen',
          )}
        </ButtonText>
      </NextButton>
    </React.Fragment>
  );
};

export default Summary;
